import React from 'react'

// NOTE: this was a legacy "factory component" — (props) => ({ render() {} }).
// React calls the factory once at mount, so the onChange handler captured
// onChangeText/prop from the FIRST render; when the same instance was reused
// for a different target (constant key), changes wrote to the wrong object.
// Rewritten as a proper class so the handler always reads current props.
// Behaviour preserved: options may be strings or {value,label}; the emitted
// value is the option's visible text (label), exactly as before.
class SelectComponent extends React.Component {
    render() {
        const { header, value, onChangeText, prop, options } = this.props;

        let v = '';
        if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            v = value.label;
        }
        else {
            if (typeof options === 'object' && Array.isArray(options)) {
                const found = options.find(i => i.value == value);
                if (found) v = found.label;
                else v = value;
            }
            else v = value;
        }

        const labels = !options ? [] : options.map(i => (typeof i === 'object' ? i.label : i));
        const selectedValue = labels.includes(v) ? v : 'Please select';

        return (<div className="form-group">
            <label>{header}</label>
            <select value={selectedValue} onChange={(e) => { onChangeText(prop, e.target.value) }} className="form-control">
                <option>{'Please select'}</option>
                {labels.map(l => <option key={prop + '_' + l} value={l}>{l}</option>)}
            </select>
        </div >);
    }
}

export default SelectComponent;
